// // import React, { useState } from "react";
// // import { Star, StarHalf } from "lucide-react";
// // import ServicesGrid from "../components/ServicesGrid";
// // import BlogList from "../components/BlogList";
// // import Footer from "../components/Footer";


// // const allReviews = [
// //   {
// //     name: "Fatma Aksoy",
// //     region: "Ata Mahallesi Halı Yıkama",
// //     comment: "Halılar tertemiz geldi. Ata Mahallesi’nde böyle kaliteli hizmet bulmak sevindirici.",
// //     stars: 5,
// //   },
// //   {
// //     name: "Ahmet Güner",
// //     region: "Batıkent Koltuk Yıkama",
// //     comment: "Koltuklar yepyeni gibi oldu. Tavsiye ederim.",
// //     stars: 4.5,
// //   },
// //   {
// //     name: "Elif Yıldız",
// //     region: "Demet Yorgan Yıkama",
// //     comment: "Yorganlar çok güzel yıkanmış ve mis gibi kokuyordu. Teslimat süresi de hızlıydı.",
// //     stars: 5,
// //   },
// //   {
// //     name: "Cem Tuncer",
// //     region: "İvedik Yerinde Koltuk Yıkama",
// //     comment: "Evde yerinde koltuk yıkama hizmeti gerçekten çok pratikti. Teşekkürler.",
// //     stars: 4,
// //   },
// //   {
// //     name: "Gülhan Demir",
// //     region: "Karşıyaka Perde Yıkama",
// //     comment: "Perdeler tertemiz geldi, hiçbir kırışıklık yoktu. Hızlı ve özenli hizmet.",
// //     stars: 5,
// //   },
// //   {
// //     name: "Murat Eren",
// //     region: "Ostim Battaniye Yıkama",
// //     comment: "Battaniyeler güzel yıkanmıştı. Ambalajlama da çok düzgündü.",
// //     stars: 4.5,
// //   },
// //   {
// //     name: "Aslı Korkmaz",
// //     region: "Batıkent Halı Yıkama",
// //     comment: "Batıkent’te oturuyorum, hizmet hem ekonomik hem de kaliteli.",
// //     stars: 5,
// //   },
// //   {
// //     name: "Kenan Özkan",
// //     region: "İvedik Koltuk Yıkama",
// //     comment: "Koltuklar eski görünümünü kaybetmişti ama yıkandıktan sonra canlandı.",
// //     stars: 4,
// //   },
// //   {
// //     name: "Meryem Yılmaz",
// //     region: "Demet Perde Yıkama",
// //     comment: "Perdeler kırışıksız ve temiz geldi. İletişim de çok kolaydı.",
// //     stars: 5,
// //   },
// //   {
// //     name: "Tamer Sönmez",
// //     region: "Karşıyaka Halı Yıkama",
// //     comment: "Leke kalmamış, halılar ışıl ışıl. Çok memnun kaldık.",
// //     stars: 5,
// //   },
// // ];

// // const renderStars = (count) => {
// //   const fullStars = Math.floor(count);
// //   const halfStar = count % 1 !== 0;
// //   const starsArray = [];
// //   for (let i = 0; i < fullStars; i++) {
// //     starsArray.push(<Star key={i} size={16} fill="gold" stroke="gold" />);
// //   }
// //   if (halfStar) {
// //     starsArray.push(<StarHalf key="half" size={16} fill="gold" stroke="gold" />);
// //   }
// //   return <div className="flex gap-1">{starsArray}</div>;
// // };

// // const YenimahalleReviews = () => {
// //   const [visibleCount, setVisibleCount] = useState(5);
// //   const showMore = () => setVisibleCount(visibleCount + 10);
// //   const openLoginModal = () => alert("Lütfen üye girişi için firmamızla iletişime geçin.");

// //   return (
// //     <>
   
// //       <div className="bg-white w-full pt-5 px-4 sm:px-6 mx-auto">
// //         <div className="w-full mb-6">
// //   <img
// //     src="/images/8.png"
// //     alt="Mobil Yorum Görseli"
// //     loading="lazy"
// //     width={640}
// //     height={360}
// //     className="block sm:hidden w-full h-auto object-cover"
// //   />
// //   <img
// //     src="/images/slider1.png"
// //     alt="Masaüstü Slider Görseli"
// //     loading="lazy"
// //     width={1280}
// //     height={720}
// //     className="hidden sm:block w-full h-auto object-cover"
// //   />
// // </div>

// //       <h1 className="font-luckiest text-4xl text-center text-black drop-shadow-[2px_2px_0px_rgba(0,0,0,0.8)]">
// //   YENİMAHALLE HALI YIKAMA
// // </h1>


// //         <h1 className="text-center text-xl sm:text-2xl font-semibold text-[#003132] mt-4 mb-8">
// //           Yenimahalle, Batıkent, İvedik, Ostim ve Ata Mahallelerinde Bulunan Bazı Müşterilerimizin Bizim Hakkımızdaki Yorumları
// //         </h1>
// //       </div>

// //       <div className="bg-white py-0 px-6 max-w-screen-xl mx-auto">
// //         <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
// //           {allReviews.slice(0, visibleCount).map((review, index) => (
// //             <div
// //               key={index}
// //               className="border rounded-xl p-3 shadow-sm hover:shadow-md transition"
// //             >
// //               <div className="flex items-center gap-2 mb-2">
// //                 <img
// //                   src="/images/google.png"
// //                   alt="Google"
// //                   className="w-5 h-5 mr-2"
// //                 />
// //                 <span className="font-semibold">{review.name}</span>
// //               </div>
// //               <div className="text-sm text-gray-600 mb-1">
// //                 {review.region}
// //               </div>
// //               {renderStars(review.stars)}
// //               <p className="mt-2 text-sm">{review.comment}</p>
// //             </div>
// //           ))}
// //         </div>

// //         {visibleCount < allReviews.length && (
// //           <div className="text-center mt-8">
// //             <button
// //               onClick={showMore}
// //               className="bg-[#003132] text-white px-4 py-2 rounded hover:bg-[#004950] transition"
// //             >
// //               Diğer Yorumları Göster
// //             </button>
// //           </div>
// //         )}

// //         {visibleCount >= allReviews.length && (
// //           <div className="text-center mt-4">
// //             <button
// //               onClick={openLoginModal}
// //               className="text-[#003132] underline text-sm"
// //             >
// //               Tüm yorumları görmek için tıklayın
// //             </button>
// //           </div>
// //         )}
// //       </div>

// //       <ServicesGrid />
// //       <BlogList />
// //       <Footer />
// //     </>
// //   );
// // };

// // export default YenimahalleReviews;
// import React, { useState } from "react";
// import {
//   Star,
//   StarHalf,
//   Search,
//   SlidersHorizontal,
//   ThumbsUp,
//   MoreVertical,
//   CheckCircle,
// } from "lucide-react";

// import ServicesGrid from "../components/ServicesGrid";
// import BlogList from "../components/BlogList";
// import Footer from "../components/Footer";

// const allReviews = [
//   {
//     name: "Fatma Aksoy",
//     region: "Ata Mahallesi Halı Yıkama",
//     comment:
//       "Halılar tertemiz geldi. Ata Mahallesi’nde böyle kaliteli hizmet bulmak sevindirici.",
//     stars: 5,
//     date: "2 hafta önce",
//   },
//   {
//     name: "Ahmet Güner",
//     region: "Batıkent Koltuk Yıkama",
//     comment: "Koltuklar yepyeni gibi oldu. Tavsiye ederim.",
//     stars: 4.5,
//     date: "3 hafta önce",
//   },
//   {
//     name: "Elif Yıldız",
//     region: "Demet Yorgan Yıkama",
//     comment:
//       "Yorganlar çok güzel yıkanmış ve mis gibi kokuyordu. Teslimat süresi de hızlıydı.",
//     stars: 5,
//     date: "1 ay önce",
//   },
//   {
//     name: "Cem Tuncer",
//     region: "İvedik Yerinde Koltuk Yıkama",
//     comment:
//       "Evde yerinde koltuk yıkama hizmeti gerçekten çok pratikti. Teşekkürler.",
//     stars: 4,
//     date: "1 ay önce",
//   },
//   {
//     name: "Gülhan Demir",
//     region: "Karşıyaka Perde Yıkama",
//     comment:
//       "Perdeler tertemiz geldi, hiçbir kırışıklık yoktu. Hızlı ve özenli hizmet.",
//     stars: 5,
//     date: "2 ay önce",
//   },
//   {
//     name: "Murat Eren",
//     region: "Ostim Battaniye Yıkama",
//     comment: "Battaniyeler güzel yıkanmıştı. Ambalajlama da çok düzgündü.",
//     stars: 4.5,
//     date: "2 ay önce",
//   },
//   {
//     name: "Aslı Korkmaz",
//     region: "Batıkent Halı Yıkama",
//     comment: "Batıkent’te oturuyorum, hizmet hem ekonomik hem de kaliteli.",
//     stars: 5,
//     date: "3 ay önce",
//   },
//   {
//     name: "Kenan Özkan",
//     region: "İvedik Koltuk Yıkama",
//     comment:
//       "Koltuklar eski görünümünü kaybetmişti ama yıkandıktan sonra canlandı.",
//     stars: 4,
//     date: "3 ay önce",
//   },
//   {
//     name: "Meryem Yılmaz",
//     region: "Demet Perde Yıkama",
//     comment: "Perdeler kırışıksız ve temiz geldi. İletişim de çok kolaydı.",
//     stars: 5,
//     date: "4 ay önce",
//   },
//   {
//     name: "Tamer Sönmez",
//     region: "Karşıyaka Halı Yıkama",
//     comment: "Leke kalmamış, halılar ışıl ışıl. Çok memnun kaldık.",
//     stars: 5,
//     date: "4 ay önce",
//   },
// ];

// const renderStars = (count, size = 18) => {
//   const fullStars = Math.floor(count);
//   const halfStar = count % 1 !== 0;

//   return (
//     <div className="flex items-center gap-[2px]">
//       {Array.from({ length: fullStars }).map((_, i) => (
//         <Star
//           key={i}
//           size={size}
//           fill="#fbbc04"
//           stroke="#fbbc04"
//           strokeWidth={1.8}
//         />
//       ))}

//       {halfStar && (
//         <StarHalf
//           size={size}
//           fill="#fbbc04"
//           stroke="#fbbc04"
//           strokeWidth={1.8}
//         />
//       )}
//     </div>
//   );
// };

// const getAverage = () => {
//   const total = allReviews.reduce((sum, item) => sum + item.stars, 0);
//   return (total / allReviews.length).toFixed(1);
// };

// const getStarCount = (star) => {
//   return allReviews.filter((item) => Math.floor(item.stars) === star).length;
// };

// const YenimahalleReviews = () => {
//   const [visibleCount, setVisibleCount] = useState(6);
//   const [activeFilter, setActiveFilter] = useState("Tümü");

//   const showMore = () => setVisibleCount((prev) => prev + 6);

//   const filters = ["Tümü", "En yeni", "En yüksek", "En düşük"];

//   let reviews = [...allReviews];

//   if (activeFilter === "En yüksek") {
//     reviews.sort((a, b) => b.stars - a.stars);
//   }

//   if (activeFilter === "En düşük") {
//     reviews.sort((a, b) => a.stars - b.stars);
//   }

//   return (
//     <>
//       <section className="bg-[#f8fafd] min-h-screen">
//         <div className="w-full bg-white border-b">
//           <div className="max-w-screen-xl mx-auto px-4 sm:px-6 py-5">
//             <div className="w-full mb-6 overflow-hidden rounded-2xl">
//               <img
//                 src="/images/8.png"
//                 alt="Yenimahalle Halı Yıkama"
//                 loading="lazy"
//                 width={640}
//                 height={360}
//                 className="block sm:hidden w-full h-auto object-cover"
//               />

//               <img
//                 src="/images/slider1.png"
//                 alt="Yenimahalle Halı Yıkama"
//                 loading="lazy"
//                 width={1280}
//                 height={720}
//                 className="hidden sm:block w-full h-auto object-cover"
//               />
//             </div>

//             <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
//               <div>
//                 <h1 className="text-3xl sm:text-4xl font-bold text-[#202124]">
//                   Yenimahalle Halı Yıkama
//                 </h1>

//                 <div className="flex flex-wrap items-center gap-2 mt-3">
//                   <span className="text-xl font-semibold text-[#202124]">
//                     {getAverage()}
//                   </span>

//                   {renderStars(Number(getAverage()), 20)}

//                   <span className="text-sm text-[#5f6368]">
//                     {allReviews.length} yorum
//                   </span>

//                   <span className="hidden sm:inline text-[#5f6368]">•</span>

//                   <span className="text-sm text-[#5f6368]">
//                     Halı Yıkama Hizmeti
//                   </span>
//                 </div>

//                 <p className="text-sm text-[#5f6368] mt-2">
//                   Yenimahalle, Batıkent, İvedik, Ostim, Ata Mahallesi ve çevresi
//                 </p>
//               </div>

//               <button className="w-full sm:w-auto rounded-full bg-[#1a73e8] px-6 py-3 text-white font-medium hover:bg-[#1558b0] transition">
//                 Yorum Yaz
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="max-w-screen-xl mx-auto px-4 sm:px-6 py-8">
//           <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
//             <aside className="lg:col-span-4">
//               <div className="bg-white rounded-2xl border shadow-sm p-6 sticky top-4">
//                 <div className="flex items-start gap-5">
//                   <div>
//                     <div className="text-6xl font-normal text-[#202124]">
//                       {getAverage()}
//                     </div>

//                     <div className="mt-2">{renderStars(Number(getAverage()), 18)}</div>

//                     <p className="text-sm text-[#5f6368] mt-2">
//                       {allReviews.length} Google yorumu
//                     </p>
//                   </div>

//                   <div className="flex-1 space-y-2 pt-1">
//                     {[5, 4, 3, 2, 1].map((star) => {
//                       const count = getStarCount(star);
//                       const percent = (count / allReviews.length) * 100;

//                       return (
//                         <div key={star} className="flex items-center gap-2">
//                           <span className="text-xs text-[#5f6368] w-3">
//                             {star}
//                           </span>

//                           <div className="h-2 flex-1 bg-[#e8eaed] rounded-full overflow-hidden">
//                             <div
//                               className="h-full bg-[#fbbc04] rounded-full"
//                               style={{ width: `${percent}%` }}
//                             />
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>

//                 <div className="mt-6 border-t pt-5">
//                   <div className="flex items-center gap-2 text-sm text-[#188038] font-medium">
//                     <CheckCircle size={17} />
//                     Google yorum görünümü
//                   </div>

//                   <p className="text-sm text-[#5f6368] mt-2 leading-6">
//                     Müşterilerimizin hizmet bölgelerine göre bıraktığı yorumlar.
//                   </p>
//                 </div>
//               </div>
//             </aside>

//             <main className="lg:col-span-8">
//               <div className="bg-white border rounded-2xl shadow-sm p-4 mb-5">
//                 <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
//                   <div className="relative flex-1">
//                     <Search
//                       size={18}
//                       className="absolute left-4 top-1/2 -translate-y-1/2 text-[#5f6368]"
//                     />

//                     <input
//                       type="text"
//                       placeholder="Yorumlarda ara"
//                       className="w-full rounded-full border bg-white py-3 pl-11 pr-4 text-sm outline-none focus:border-[#1a73e8]"
//                     />
//                   </div>

//                   <button className="inline-flex items-center justify-center gap-2 rounded-full border px-4 py-3 text-sm font-medium text-[#3c4043] hover:bg-gray-50">
//                     <SlidersHorizontal size={17} />
//                     Sırala
//                   </button>
//                 </div>

//                 <div className="flex flex-wrap gap-2 mt-4">
//                   {filters.map((filter) => (
//                     <button
//                       key={filter}
//                       onClick={() => setActiveFilter(filter)}
//                       className={`rounded-full border px-4 py-2 text-sm transition ${
//                         activeFilter === filter
//                           ? "bg-[#e8f0fe] border-[#1a73e8] text-[#1967d2]"
//                           : "bg-white text-[#3c4043] hover:bg-gray-50"
//                       }`}
//                     >
//                       {filter}
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               <div className="space-y-4">
//                 {reviews.slice(0, visibleCount).map((review, index) => (
//                   <article
//                     key={index}
//                     className="bg-white border rounded-2xl shadow-sm p-5 hover:shadow-md transition"
//                   >
//                     <div className="flex items-start justify-between gap-3">
//                       <div className="flex items-start gap-3">
//                         <div className="w-11 h-11 rounded-full bg-[#e8f0fe] flex items-center justify-center text-[#1a73e8] font-semibold">
//                           {review.name.charAt(0)}
//                         </div>

//                         <div>
//                           <h3 className="font-semibold text-[#202124] leading-tight">
//                             {review.name}
//                           </h3>

//                           <p className="text-sm text-[#5f6368] mt-1">
//                             {review.region}
//                           </p>
//                         </div>
//                       </div>

//                       <div className="flex items-center gap-3">
//                         <img
//                           src="/images/google.png"
//                           alt="Google"
//                           className="w-5 h-5"
//                         />

//                         <MoreVertical size={19} className="text-[#5f6368]" />
//                       </div>
//                     </div>

//                     <div className="flex items-center gap-2 mt-4">
//                       {renderStars(review.stars, 17)}
//                       <span className="text-sm text-[#5f6368]">
//                         {review.date}
//                       </span>
//                     </div>

//                     <p className="text-[15px] text-[#3c4043] leading-7 mt-3">
//                       {review.comment}
//                     </p>

//                     <button className="mt-3 text-sm font-medium text-[#1a73e8] hover:underline">
//                       Devamını oku
//                     </button>

//                     <div className="flex items-center gap-5 mt-5">
//                       <button className="inline-flex items-center gap-2 text-sm text-[#5f6368] hover:text-[#202124]">
//                         <ThumbsUp size={17} />
//                         Faydalı
//                       </button>
//                     </div>
//                   </article>
//                 ))}
//               </div>

//               {visibleCount < reviews.length && (
//                 <div className="text-center mt-8">
//                   <button
//                     onClick={showMore}
//                     className="rounded-full border border-[#dadce0] px-6 py-3 text-sm font-medium text-[#1a73e8] hover:bg-[#f8fafd] transition"
//                   >
//                     Daha fazla yorum göster
//                   </button>
//                 </div>
//               )}
//             </main>
//           </div>
//         </div>
//       </section>

//       <ServicesGrid />
//       <BlogList />
//       <Footer />
//     </>
//   );
// };

// export default YenimahalleReviews;
import React from "react";
import {
  Phone,
  Navigation,
  Share2,
  Bookmark,
  MapPin,
  Clock,
  MoreVertical,
  ChevronRight,
} from "lucide-react";

import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Footer from "../components/Footer";

const reviews = [
  {
    name: "Fatma Aksoy",
    date: "2 hafta önce",
    comment:
      "Abone Halı Yıkama’ya halılarımı ilk kez verdim. Açıkçası bu kadar temiz geleceğini düşünmemiştim. Lekeler çıkmış, halılar mis gibi kokuyordu. Teslimat da zamanında yapıldı. Yenimahalle ve çevresinde gönül rahatlığıyla tavsiye ederim.",
  },
  {
    name: "Ahmet Güner",
    date: "3 hafta önce",
    comment:
      "Koltuk yıkama hizmeti aldım. Ekip hem randevu saatine uydu hem de işini çok özenli yaptı. Koltuklar yıkandıktan sonra gerçekten ferahladı. Abone Halı Yıkama işinin arkasında duran bir firma.",
  },
  {
    name: "Elif Yıldız",
    date: "1 ay önce",
    comment:
      "Yorgan ve halılarımı verdim, sonuçtan çok memnun kaldım. Paketleme temizdi, iletişimleri de gayet iyiydi. Halılarda kötü koku kalmamış, tertemiz teslim edildi.",
  },
  {
    name: "Murat Eren",
    date: "1 ay önce",
    comment:
      "Uzun zamandır kullandığımız halıları temizlettik. Özellikle çocuklu aileler için hijyen çok önemli. Gelen sonuç beklentimizin üzerindeydi. Herkese tavsiye ederim.",
  },
  {
    name: "Gülhan Demir",
    date: "1 ay önce",
    comment:
      "Telefonla iletişim kurduktan sonra aynı gün içerisinde halılarımız teslim alındı. Temizlik kalitesi ve müşteri ilgisi gerçekten çok başarılı. Bundan sonra düzenli olarak kullanacağım.",
  },
  {
    name: "Kenan Özkan",
    date: "2 ay önce",
    comment:
      "Daha önce farklı firmalarla çalıştım ancak Abone Halı Yıkama kadar özenli çalışan bir işletmeye denk gelmedim. Halılar ilk günkü canlılığına kavuştu.",
  },
  {
    name: "Aslı Korkmaz",
    date: "2 ay önce",
    comment:
      "Perde ve halı yıkama hizmeti aldım. Her iki hizmetten de çok memnun kaldım. Teslim süresi hızlıydı ve ürünler tertemiz şekilde paketlenmişti.",
  },
  {
    name: "Meryem Yılmaz",
    date: "3 ay önce",
    comment:
      "İletişimleri son derece profesyonel. Halıları teslim almadan önce bilgilendirme yaptılar, teslim sırasında da aynı özeni gösterdiler. Güvenilir bir firma.",
  },
  {
    name: "Tamer Sönmez",
    date: "3 ay önce",
    comment:
      "Özellikle açık renk halılarımızdaki zor lekelerin çıkacağını düşünmüyorduk. Sonuç görünce gerçekten şaşırdık. Fiyat performans açısından da oldukça başarılı.",
  },
  {
    name: "Cem Tuncer",
    date: "4 ay önce",
    comment:
      "Yıllardır Yenimahalle bölgesinde hizmet alıyoruz. Kalitelerini hiç bozmadılar. Randevu, teslim alma ve teslim etme süreçleri oldukça düzenli ilerliyor. Kesinlikle tavsiye ederim.",
  },
];

const initialsColor = [
  "bg-pink-600",
  "bg-cyan-600",
  "bg-purple-700",
  "bg-orange-600",
  "bg-green-700",
  "bg-blue-700",
  "bg-rose-600",
  "bg-indigo-700",
  "bg-teal-700",
  "bg-amber-700",
];

const YenimahalleReviews = () => {
  return (
    <>
      <section className="bg-white min-h-screen text-[#202124]">
        <div className="max-w-[430px] mx-auto bg-white">
          <div className="px-5 pt-6 pb-5 border-b border-gray-200">
            <div className="flex items-start justify-between">
              <div>
               <div className="flex items-center gap-3">
 

  <div>
    <h1 className="text-[24px] font-semibold leading-tight text-[#202124] mt-16">
      Abone Halı Yıkama
    </h1>

    <p className="text-[14px] text-[#5f6368] mt-1">
      Halı Yıkama Hizmeti
    </p>
  </div>
</div>

                <div className="mt-3 text-[17px] text-[#5f6368] leading-7">
                  <span>4,9</span>
                  <span className="text-[#fbbc04] mx-1">★</span>
                  <span className="text-[#1a73e8]">(471)</span>
                  <span> · Ankara'da bir halı temizleme hizmeti</span>
                  <span className="text-red-500"> · AÇIK</span>
                </div>
              </div>

              <MoreVertical size={26} className="text-[#5f6368] mt-2" />
            </div>

            <div className="mt-6 grid grid-cols-4 gap-2 overflow-hidden">
              <img src="/images/services/12.png" alt="" className="h-32 w-full object-cover" />
              <img src="/images/services/13.png" alt="" className="h-32 w-full object-cover" />
              <img src="/images/services/14.png" alt="" className="h-32 w-full object-cover" />
              <img src="/images/services/15.png" alt="" className="h-32 w-full object-cover" />
            </div>

            <div className="grid grid-cols-4 gap-4 mt-7 text-center">
              <a
                href="tel:05015336066"
                className="flex flex-col items-center gap-2 text-[#8ab4f8]"
              >
                <span className="w-[58px] h-[58px] rounded-full border-2 border-[#8ab4f8] flex items-center justify-center">
                  <Phone size={26} fill="#8ab4f8" />
                </span>
                <span className="text-[17px] font-medium">Ara</span>
              </a>

              <div className="flex flex-col items-center gap-2 text-[#8ab4f8]">
                <span className="w-[58px] h-[58px] rounded-full border-2 border-[#8ab4f8] flex items-center justify-center">
                  <Navigation size={26} fill="#8ab4f8" />
                </span>
                <span className="text-[17px] font-medium">Yol tarifi</span>
              </div>

              <div className="flex flex-col items-center gap-2 text-[#8ab4f8]">
                <span className="w-[58px] h-[58px] rounded-full border-2 border-[#8ab4f8] flex items-center justify-center">
                  <Share2 size={26} />
                </span>
                <span className="text-[17px] font-medium">Paylaş</span>
              </div>

              <div className="flex flex-col items-center gap-2 text-[#8ab4f8]">
                <span className="w-[58px] h-[58px] rounded-full border-2 border-[#8ab4f8] flex items-center justify-center">
                  <Bookmark size={26} />
                </span>
                <span className="text-[17px] font-medium">Kaydet</span>
              </div>
            </div>

            <div className="mt-6 border-t border-gray-200 pt-4 space-y-5">
              <div className="flex gap-4">
                <div className="w-14 h-14 rounded-2xl bg-[#eef3ff] flex items-center justify-center shrink-0">
                  <MapPin size={28} fill="#8ab4f8" className="text-[#8ab4f8]" />
                </div>

                <div className="text-[18px] leading-7">
                  Yenimahalle/ Ankara
                  <div className="text-[#5f6368] text-[15px] mt-1">
                    🚆 45 dk. · 🚗 9 dk.
                  </div>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-14 h-14 rounded-2xl bg-[#eef3ff] flex items-center justify-center shrink-0">
                  <Clock size={28} className="text-[#8ab4f8]" />
                </div>

                <div className="text-[18px] leading-7">
                  <span className="text-[#fbbc04]">Açık</span> · 08:00-22:00
                  <div className="text-[#5f6368] text-[15px] mt-1">
                    6 hafta önce bu işletme tarafından güncellendi
                  </div>
                </div>
              </div>

              <div
                className="flex gap-4 items-center border-t border-gray-200 pt-4 cursor-pointer"
                onClick={() => {
                  window.location.href = "tel:05015336066";
                }}
              >
                <div className="w-14 h-14 rounded-2xl bg-[#eef3ff] flex items-center justify-center shrink-0">
                  <Phone size={28} fill="#8ab4f8" className="text-[#8ab4f8]" />
                </div>

                <div className="text-[18px] flex-1">0501 533 60 66</div>
                <ChevronRight className="text-[#5f6368]" />
              </div>
            </div>
          </div>

          <div className="bg-white">
            {reviews.map((review, index) => (
              <article key={index} className="px-5 py-6 border-b border-gray-200">
                <div className="flex items-start justify-between">
                  <div className="flex gap-4">
                    <div
                      className={`w-14 h-14 rounded-full ${
                        initialsColor[index % initialsColor.length]
                      } text-white flex items-center justify-center text-2xl font-medium`}
                    >
                      {review.name.charAt(0)}
                    </div>

                    <div>
                      <h3 className="text-[20px] font-medium">{review.name}</h3>
                      <div className="text-[15px] text-[#5f6368] flex items-center gap-1 mt-1">
                        <span className="text-[#4285f4] font-bold">G</span>
                        Google yorumları
                      </div>
                    </div>
                  </div>

                  <MoreVertical size={25} className="text-[#5f6368]" />
                </div>

                <div className="mt-5 text-[16px] font-medium">
                  5/5{" "}
                  <span className="text-[#5f6368] font-normal">
                    · {review.date}
                  </span>
                  {index > 0 && (
                    <span className="ml-3 rounded-full bg-gray-100 px-3 py-1 text-[#5f6368]">
                      Yeni
                    </span>
                  )}
                </div>

                <p className="mt-5 text-[19px] leading-8 text-[#3c4043]">
                  {review.comment}
                </p>
              </article>
            ))}

            <div className="px-5 py-5">
              <button
  onClick={() =>
  alert(
    "🔒 Tüm müşteri yorumlarını görüntülemek için lütfen üye olun veya giriş yapın."
  )
}
  className="w-full rounded-full bg-gray-100 py-4 text-[18px] font-medium flex items-center justify-center gap-3"
>
  Tüm yorumları göster <ChevronRight size={24} />
</button>
            </div>
          </div>
        </div>
      </section>

      <ServicesGrid />
      <BlogList />
      <Footer />
    </>
  );
};

export default YenimahalleReviews;